import { render, staticRenderFns } from "./PraticaDialog.vue?vue&type=template&id=e8b1b2fc"
import script from "./PraticaDialog.vue?vue&type=script&lang=js"
export * from "./PraticaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports